export { default as WalletModal } from "./WalletModal.svelte";
